import { ToolkitPropertyEnum, isUndefined, makeLookup } from '@aloft/toolkit-shared';

import { ProductColor } from '../../../toolkit-sui/dist/common/types.ts';
import { PropertyPinStatus } from '../components/Tkv2Map/types.ts';
import { getPropertyPinStatus } from './getPropertyPinStatus.ts';

const getPinColorForPinStatus = makeLookup<PropertyPinStatus, ProductColor>({
  cases: [
    ['Active', 'pinActive'],
    ['Pending', 'pinPending'],
    ['Sold', 'pinSold'],
    ['Rented', 'pinRented'],
    ['Off-Market', 'pinOffMarket'],
    ['other', 'pinOther'],
    ['Subject', 'pinSubject'],
  ],
  default: 'pinOffMarket',
});

export function getColorForStatusOrSubject(
  statusOrSubject?: ToolkitPropertyEnum<'ListingStatusType'> | 'Subject',
): ProductColor {
  if (isUndefined(statusOrSubject)) return getPinColorForPinStatus('Off-Market');

  return getPinColorForPinStatus(getPropertyPinStatus(statusOrSubject));
}
